<div id="viewLicenseModal" class="modal" style="display:none" appDraggable dragTarget="#viewLicenseModal" dragHandle="#viewLicenseModalHeader"
  role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <!-- Dialog Header -->
      <div class="modal-header" id="viewLicenseModalHeader">
        <button type="button" class="close" data-dismiss="modal" (click)="hideDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title">
          <i class="fa fa-pencil"></i> View License Details</h4>
      </div>

      <!-- Dialog Body -->
      <div class="modal-body">
        <div class="form-horizontal" *ngIf="mLicense != null">

          <!-- License ID -->
          <div class="form-group">
            <label class="control-label col-sm-4">License ID: </label>
            <div class="col-sm-8">
              <div class="form-control disabled">
                {{mLicense.id}}
              </div>
            </div>
          </div>

          <!-- License Type -->
          <div class="form-group">
            <label class="control-label col-sm-4">License Type: </label>
            <div class="col-sm-8">
              <div class="form-control disabled">
                {{ mLicense?.license_details?.license_type }}
              </div>
            </div>
          </div>

          <!-- Licensed Modules -->
          <div class="form-group">
            <label class="control-label col-sm-4">Licensed Modules: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <tbody>
                  <tr *ngFor="let module of mLicense?.license_details?.licensed_modules">
                    {{ module }}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Entity Type Limits -->
          <div class="form-group">
            <label class="control-label col-sm-4">Entity Type Limits: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Entity Type</th>
                    <th>Limit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let limit of getEntityTypeLimits()">
                    <td>{{ limit.mEntityType }}</td>
                    <td>{{ limit.mLimit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Licensed Hardware -->
          <div class="form-group">
            <label class="control-label col-sm-4">Licensed Hardware: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Hardware Type</th>
                    <th>Hardware Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let hw of mLicense?.license_details?.licensed_hardware">
                    <td>{{ hw.hardware_type }}</td>
                    <td>{{ hw.hardware_value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Expiration Date -->
          <div class="form-group">
            <label class="control-label col-sm-4">Expiration Date: </label>
            <div class="col-sm-8">
              <div class="form-control disabled">
                {{ mLicense?.license_details?.expiration_date }}
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Dialog Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">
          <i class="fa fa-ban" aria-hidden="true"></i> CLOSE</button>
      </div>
    </div>
  </div>
</div>
